import React from "react";
import { Line } from "@nivo/line";
import { PointPicker, PointPickerFlat } from "../points/point-picker";
import { TooltipBothAxes } from "./tooltip-both-axes";
import { IntegerAxis, SkipTicksAxis } from "../components/line-chart-axes";

export const DashboardLineChartType1 = (props) => {
  const { data, width } = props;

  let singleLegendProps = props.singleLegendProps;
  if (!singleLegendProps || Object.keys(singleLegendProps).length === 0) {
    singleLegendProps = {};
  }

  return (
    <Line
      margin={{ left: 40, bottom: 20, top: 40, right: 20 }}
      animate={true}
      enableSlices="x"
      enableArea={true}
      enableGridX={false}
      yScale={{
        type: "linear",
        stacked: true,
      }}
      curve={"linear"}
      // colors={{ scheme: "paired" }}
      colors={["#4AD3DC", "#FEA58A", "#EA91AD", "#F8C98D", "#BEA7EC"]}
      fill={[{ match: "*", id: "color" }]}
      pointSymbol={PointPicker}
      pointSize={6}
      pointColor="#fff"
      pointBorderWidth={2}
      pointBorderColor={{ from: 'serieColor' }}
      areaOpacity={0.5}
      axisLeft={IntegerAxis}
      axisBottom={SkipTicksAxis(110, width, data[0]?.data)}
      legends={[
        {
          anchor: "top",
          direction: "row",
          justify: false,
          translateX: 0,
          translateY: -40,
          itemsSpacing: 0,
          itemWidth: 100,
          itemHeight: 18,
          itemTextColor: "#999",
          itemDirection: "left-to-right",
          itemOpacity: 1,
          // symbolSize: 18,
          // symbolShape: (props) => {
          //   return (
          //     <g transform={`translate(${props.size / 2} ${props.size / 2})`}>
          //       <PointPickerFlat
          //         {...props}
          //         color={props.fill}
          //         symbol={data.find((d) => d.id === props.id).symbol}
          //       />
          //     </g>
          //   );
          // },
          symbolSize: 8,
          symbolShape: 'circle',
          toggleSerie: true,
          effects: [
            {
              on: "hover",
              style: {
                itemTextColor: "#000",
              },
            },
          ],
          ...singleLegendProps,
        },
      ]}
      sliceTooltip={TooltipBothAxes}
      theme={{
        axis: {
          domain: {
            // line: { stroke: '#77777777', strokeWidth: 0.5 }
          },
          legend: {
            text: { fill: "#999", fontSize: 10, fontWeight: "bold" }
          },
          ticks: {
            line: { stroke: '#77777722', strokeWidth: 0.5 },
            text: { fill: "#999", fontSize: 10 }
          },
        },
        grid: {
          line: {
            stroke: '#77777722',
            strokeWidth: 0.5
          }
        },
        labels: {
          text: { fontSize: 10, fontWeight: "bold" }
        },
        legends: {
          text: { fontSize: 10, fontWeight: "bold" }
        }
      }}
      {...props}
    />
  );
};
